.radioGroup {
  display: flex;
  gap: 1.5rem;
}

.radioOption {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
